const Blockly = require('blockly');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const convertToBoolean = require('../../../../helpers/convertToBoolean');

const TOOLTIP =
    'Display data from an embedded array as an inline table within a card. Supports row highlighting and display modifiers.';

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
    blocklyBlock.setInputsInline(false);
    line1OfInputs.appendField('  Property:').appendField(new Blockly.FieldTextInput(''), 'propertyName');

    blocklyBlock
        .appendDummyInput()
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField('  Allow Removal:')
        .appendField(new Blockly.FieldCheckbox('FALSE'), 'allowRemoval');

    blocklyBlock
        .appendDummyInput()
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField('  Max Rows:')
        .appendField(new Blockly.FieldNumber(5, 1, undefined, 1), 'maxRows');

    blocklyBlock.appendStatementInput('columns').setCheck(['listColumn']).appendField('Columns:');
}

function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties([
        'propertyName',
        { key: 'allowRemoval', handler: convertToBoolean },
        { key: 'maxRows', handler: val => Number.parseInt(val) }
    ]);
    code.label = code.title;
    code.dataType = 'embeddedList';
    return code;
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
